// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2GgDI","range":"MonthRangeSwitch_range__1ATEh","disabled":"MonthRangeSwitch_disabled__39onF"};